import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCriar: (descricao: string) => Promise<boolean>;
}

export const ModalCriarAgrupamento: React.FC<Props> = ({
  isOpen,
  onClose,
  onCriar
}) => {
  const [descricao, setDescricao] = useState('');
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDescricao('');
    }
  }, [isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!descricao.trim() || carregando) return;

    setCarregando(true);
    try {
      const sucesso = await onCriar(descricao.trim());
      if (sucesso) {
        onClose();
      }
    } finally {
      setCarregando(false);
    }
  };

  const handleClose = () => {
    if (!carregando) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-zinc-800 rounded-lg max-w-md w-full shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-zinc-200 dark:border-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
            Novo Agrupamento
          </h2>
          <button
            onClick={handleClose}
            disabled={carregando}
            className="p-2 text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300 transition-colors disabled:opacity-50"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="p-6">
            <div className="mb-4">
              <label 
                htmlFor="descricao" 
                className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2"
              >
                Descrição *
              </label>
              <input
                id="descricao"
                type="text"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value.toUpperCase())}
                placeholder="DIGITE A DESCRIÇÃO DO AGRUPAMENTO..."
                className="w-full px-3 py-2 border border-zinc-300 dark:border-zinc-600 rounded-lg
                         focus:ring-2 focus:ring-blue-500 focus:border-transparent
                         bg-white dark:bg-zinc-700 text-zinc-900 dark:text-zinc-100
                         placeholder-zinc-500 dark:placeholder-zinc-400 uppercase"
                autoFocus
                disabled={carregando}
                required
                minLength={1}
                maxLength={200}
              />
              <p className="mt-1 text-xs text-zinc-500 dark:text-zinc-400">
                {descricao.length}/200 caracteres
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 p-6 border-t border-zinc-200 dark:border-zinc-700">
            <button
              type="button"
              onClick={handleClose}
              disabled={carregando}
              className="px-4 py-2 text-zinc-700 dark:text-zinc-300 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!descricao.trim() || carregando}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-zinc-300 dark:disabled:bg-zinc-600 text-white rounded-lg transition-colors flex items-center gap-2"
            >
              {carregando ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Criando...
                </>
              ) : (
                'Criar Agrupamento'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};